import { TEST_IDS } from "constants/TestIds";

import { Tree } from "../../Tree";
import { CountryItem } from "../CountryItem";
import { RegionLabel } from "./RegionLabel";
import { useRegionItem } from "./useRegionItem";

import type { RegionWithCountries } from "../types";

export interface RegionItemProps {
  region: RegionWithCountries;
}

export function RegionItem({ region }: RegionItemProps) {
  const { regionName, regionCode, countries } = region;

  const {
    isRegionSelected,
    isRegionIndeterminate,
    handleToggleRegion,
  } = useRegionItem();

  return (
    <Tree.Group
      data-testid={TEST_IDS.getRegion(String(regionCode))}
      label={
        <RegionLabel
          label={regionName}
          id={regionCode}
          isSelected={isRegionSelected(region)}
          isIndeterminate={isRegionIndeterminate(region)}
          onClick={handleToggleRegion(region)}
        />
      }
    >
      {countries.map((country) => (
        <CountryItem key={country.id} country={country} />
      ))}
    </Tree.Group>
  );
}
